import React from 'react';
import LoginHeader from '../components/navbar/LoginHeader';
import Footer from '../components/footer/Footer';
import { Navigate, Outlet } from 'react-router-dom';

const protectedRoute = () => {
    let token = localStorage.getItem("token")
    return (
        <>
            {token ? (
                <>
                    <LoginHeader />
                    <Outlet />
                    <Footer
                        // getstart="/getstarted"
                        community="/community"
                        dashboard='/dashboard'
                        journal='/journal'
                        products='/products'
                        // podcast='/podcast'
                        // blog='/blog'
                        subscription='/subscription'
                        // terms='/terms'
                        // about='/about'
                        faq='/faq'
                    // contact='/contact'
                    />
                </>
            ) : <Navigate to={"/"} />}
        </>
    )
}

export default protectedRoute;